import { EPlacingType, IPublishTermsState } from '../../../types/reducers/publishTerms';

interface IParams {
  isUserInteraction: boolean;
  prevTerms: IPublishTermsState;
  nextTerms: IPublishTermsState;
}

type TPlacingType = EPlacingType | null;

export const getPlacingType = ({ isUserInteraction, prevTerms, nextTerms }: IParams): TPlacingType => {
  const isFirstLoad = !prevTerms.selectedPlacingType;

  if (isFirstLoad) {
    return nextTerms.selectedPlacingType;
  }

  const nextHasPackages = Boolean(nextTerms.packageIds.length);
  const isAllowNextPackage = prevTerms.selectedPlacingType === EPlacingType.package && nextHasPackages;

  if (isUserInteraction) {
    return isAllowNextPackage ? EPlacingType.package : EPlacingType.balance;
  }

  return nextTerms.selectedPlacingType;
};
